/**
 * Closes a megamenu
 * @param {Element} megamenu - The containing <li> element of the megamenu that you would like to close
 */
function closeMegamenu(megamenu) {
	megamenu.classList.remove("show");
	megamenu
		.querySelector(".dropdown-toggle")
		.setAttribute("aria-expanded", false);
	megamenu.querySelector(".megamenu").classList.remove("show");
	document.body.style.overflowY = "auto";
}

/**
 * Opens a megamenu
 * @param {Element} megamenu - The containing <li> element of the megamenu that you would like to open
 */
function openMegamenu(megamenu) {
	megamenu.classList.add("show");
	megamenu
		.querySelector(".dropdown-toggle")
		.setAttribute("aria-expanded", true);
	megamenu.querySelector(".megamenu").classList.add("show");
	document.body.style.overflowY = "hidden";
}

document.addEventListener("DOMContentLoaded", function () {
	let parents = document.querySelectorAll(".level0.parent");
	let overlay = document.querySelector(".desktop-menu .overlay");

	parents.forEach((parent) => {
		parent.addEventListener("mouseover", function () {
			overlay.style.visibility = "visible";
			overlay.style.opacity = "0.4";
		});

		parent.addEventListener("mouseleave", function () {
			overlay.style.visibility = "hidden";
			overlay.style.opacity = "0";
		});
	});

	// Get all megamenus
	let megamenus = Array.from(document.querySelectorAll(".has-megamenu"));

	// Loop each megamenu and add a click event listener to the containing <li> element
	for (let thisMegamenu of megamenus) {
		thisMegamenu.addEventListener("click", function (e) {
			// Check if this megamenu is already open
			var thisMenuOpen = thisMegamenu.classList.contains("show");

			// Close all other megamenus
			for (let megamenu of megamenus) {
				closeMegamenu(megamenu);
			}

			// Toggle opened state of this megamenu
			if (thisMenuOpen) {
				closeMegamenu(thisMegamenu);
			} else {
				openMegamenu(thisMegamenu);
			}
		});
	}

	// Adds trigger to toggle mobile menu on burger icon
	document
		.querySelector("[data-trigger]")
		.addEventListener("click", function () {
			let thisMenu = document.querySelector("#MobileNav");
			let thisMenuOpen = thisMenu.classList.contains("show");
			debugger;
			let closeIcon = document.querySelector(".mobile-nav-close-icon");
			let burgerIcon = document.querySelector(".mobile-nav-open-icon");

			if (thisMenuOpen) {
				thisMenu.classList.remove("show");
				closeIcon.classList.remove("show");
				burgerIcon.classList.add("show");
				document.body.classList.remove("offcanvas-active");
			} else {
				thisMenu.classList.add("show");
				burgerIcon.classList.remove("show");
				closeIcon.classList.add("show");
				document.body.classList.add("offcanvas-active");
			}
		});

	// Get mobile third level menu toggles
	let mobileToggles = Array.from(
		document.querySelectorAll(".mobile-child-toggle")
	);

	// Loop each mobile third level toggle and add event listener
	for (let thisToggle of mobileToggles) {
		thisToggle.addEventListener("click", function (e) {
			let thisMenu = thisToggle.parentElement.querySelector(".megamenu");
			if (thisMenu && thisMenu.classList.contains("show")) {
				thisMenu.classList.remove("show");
				thisToggle.dataset.toggle = "inactive";
			} else if (thisMenu && !thisMenu.classList.contains("show")) {
				thisMenu.classList.add("show");
				thisToggle.dataset.toggle = "active";
			}
		});
	}

	// Prevent the menu from closing itself when it is clicked open
	Array.from(document.querySelectorAll(".has-megamenu")).forEach((element) => {
		element.addEventListener("click", function (e) {
			e.stopPropagation();
		});
	});

	// Prevent the menu from closing itself when it is clicked inside
	Array.from(document.querySelectorAll(".megamenu")).forEach((element) => {
		element.addEventListener("click", function (e) {
			e.stopPropagation();
		});
	});
});
